<template>
  <!-- <v-btn
    @click="openCompleteTree"
    data-cy="tree-navigation-open-all"
    >Alle öffnen</v-btn
  > -->
  <div
    style="
      overflow-x: auto;
      padding-bottom: 10px;
      padding-top: 15px;
      height: calc(100% - 90px);
    "
    data-cy="tree-navigation"
    :style="treeWidth">
    <div v-if="baseData">
      <tree-node
        v-for="item in baseTree"
        :key="item.id + 'baseData'"
        :item="item" />
    </div>

    <div v-if="!baseData">
      <tree-node
        v-for="item in currentTree"
        :key="item.id"
        :item="item" />
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted, provide, reactive, ref, watch } from "vue";
import TreeNode from "./TreeNode.vue";
import { useRoute, useRouter } from "vue-router";

import { useTranslation } from "i18next-vue";
const { t } = useTranslation();

import { useSpaceStore } from "../../stores/spaceStore";
import { useTreeStore } from "@/stores/treeStore";
import { useMainStore } from "@/stores/mainStore";
import { nextTick } from "vue";
import { useSocketStore } from "@/stores/socketStore";

const route = useRoute();
const router = useRouter();
const spaceStore = useSpaceStore();
const treeStore = useTreeStore();
const mainStore = useMainStore();
const socketStore = useSocketStore();

const open = reactive([]);
const active = ref("");
const visible = reactive([]);

watch(open, (newValue) => {
  localStorage.setItem(
    "tree-open-list-" + mainStore.activeSpaceId,
    JSON.stringify(open)
  );
});

const props = defineProps({
  width: {
    default: 256,
    type: Number
  },
  baseData: {
    required: true,
    type: Boolean
  }
});

const treeWidth = computed(() => {
  return "width: " + props.width - 26 + "px";
});

const handleOpen = (id) => {
  const index = open.indexOf(id);
  if (index === -1) {
    open.push(id);
  } else {
    open.splice(index, 1);
  }
};

const handleActive = (item) => {
  active.value = item.id;
  socketStore.socket.emit("element-active", item.id);
  if (item.url) {
    router.replace({
      name: item.url
    });
  } else {
    router.replace({
      name: `calculations-${item.elementType}`,
      params: { nodeId: item.id }
    });
  }
};

provide("tree-active", active);
provide("tree-open", open);
provide("tree-visible", visible);
provide("handle-open", handleOpen);
provide("handle-active", handleActive);

const routeNodeId = computed(() => {
  return route.params.nodeId ?? route.params.parentId;
});

watch(routeNodeId, (id) => {
  if (!id) {
    // special case for root node locations
    id = "locations";
  }

  if (open.indexOf(id) === -1) {
    open.push(id);
    if (id.endsWith("part")) {
      open.push(id.split("_")[0] + "_variant");
    }
  }

  if (!visible.includes(id)) {
    open.splice(0, Infinity, ...setOpen());
  }

  active.value = id;
  socketStore.socket.emit("element-active", id);
});

function setOpen(elementTree = { children: treeStore.elementTree }, open = []) {
  if (!routeNodeId.value) {
    return ["locations"];
  }

  const childIndex = elementTree.children.findIndex(
    (element) => element.id === routeNodeId.value
  );

  if (childIndex !== -1) {
    active.value = elementTree.children[childIndex].id;
    return [...open, elementTree.children[childIndex].id];
  } else {
    const nextOpen = [...open, elementTree.id];
    for (const child of elementTree.children) {
      const result = setOpen(child, nextOpen);

      if (result.length) {
        return [...result, child.id];
      }
    }
  }

  return [];
}

function openAll(elementTree = treeStore.elementTree) {
  console.log(
    "openAll",
    elementTree.map((element) => element.title)
  );
  const open = [];
  for (const element of elementTree) {
    open.push(element.id);
    open.push(...openAll(element.children));
  }

  return open;
}

function openCompleteTree() {
  open.splice(0, Infinity, ...openAll());
}

// eslint-disable-next-line no-unused-vars
function findParentInHierachy(
  elementTree = { children: treeStore.elementTree }
) {
  if (!routeNodeId.value) {
    return treeStore.elementTree;
  }

  const childIndex = elementTree.children.findIndex(
    (element) => element.id === routeNodeId.value
  );

  console.log("childIndex", childIndex);

  if (childIndex !== -1) {
    return [elementTree];
  } else {
    console.log("Not found");
    for (const child of elementTree.children) {
      const result = findParentInHierachy(child);

      if (result) {
        return result;
      }
    }
  }

  return false;
}

// eslint-disable-next-line no-unused-vars
function transformTree(tree) {
  const result = [];
  for (const element of tree) {
    const e = {
      id: element.id,
      label: element.title,
      nodes: transformTree(element.children)
    };

    result.push(e);
  }

  return result;
}

onMounted(() => {
  const cachedList = localStorage.getItem(
    "tree-open-list-" + mainStore.activeSpaceId
  );
  if (cachedList) {
    open.push(...JSON.parse(cachedList));
    nextTick(() => {
      if (routeNodeId.value && !visible.includes(routeNodeId.value)) {
        open.splice(0, Infinity, ...setOpen());
      }

      active.value = routeNodeId.value;
    });
  } else {
    setTimeout(() => {
      console.log("asjldhfalsdkjfhklj");
      open.push(...setOpen());
    }, 500);
  }
});

const currentTree = computed(() => {
  return treeStore.elementTree;
});

function createBaseHierachy(children) {
  const result = [];
  for (const child of children.filter(
    (key) =>
      key &&
      !["nonWageLaborCost", "shiftModelDeduction", "activity"].includes(
        key.split("_")[1]
      )
  )) {
    const element = spaceStore.calculationElements[child];
    result.push({
      id: child,
      title: element.name,
      elementType: child.split("_")[1],
      children: createBaseHierachy(element.children)
    });
  }

  return result;
}

const baseTree = computed(() => {
  return [
    {
      id: "locations",
      title: t("entities.location.multiple"),
      url: "base-data",
      elementType: "base",
      children: createBaseHierachy(
        Object.keys(spaceStore.calculationElements).filter((key) =>
          key.endsWith("_location")
        )
      )
    }
  ];
});
</script>
